import { useEffect, useRef, useState } from 'react';
import './AnalyticsDropdown.scss';
import { HiOutlineChevronDown, HiOutlineChevronUp } from 'react-icons/hi';

const AnalyticsDropdown = ({
  items,
  defaultValue,
  value,
  onSelect,
  renderCustomMenu,
  width,
  fullWidth = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const getWidth = (width, fullWidth) => {
    if (fullWidth) {
      return '100%';
    }
    if (width) {
      return `${width}px`;
    }
    return 'fit-content'; // Default width if not specified
  };

  return (
    <div
      ref={dropdownRef}
      className="dropdown-container"
      style={{ width: getWidth(width, fullWidth) }}
    >
      <div
        className="analytics-dropdown"
        onClick={() => {
          setIsOpen((prev) => !prev);
        }}
      >
        <div className="dropdown-text-field">{value || defaultValue}</div>
        {isOpen ? (
          <HiOutlineChevronUp size={20} />
        ) : (
          <HiOutlineChevronDown size={20} />
        )}
      </div>
      {isOpen &&
        (renderCustomMenu ? (
          <div className="custom-items">{renderCustomMenu()}</div>
        ) : (
          <div className="dropdown-items">
            {items.map((item) => (
              <div
                className={`dropdown-item ${item.value === value && 'selected'}`}
                onClick={() => {
                  onSelect?.(item.key);
                  setIsOpen(false);
                }}
                key={item.key}
              >
                {item.value}
              </div>
            ))}
          </div>
        ))}
    </div>
  );
};

export default AnalyticsDropdown;
